import type React from "react";

import { SearchMdIcon } from "@/components/Icons/SearchMdIcon";
import type { InputProps } from "@/components/Input/Input";
import { Input } from "@/components/Input/Input";

export interface SearchInputProps extends Omit<InputProps, "prefix" | "inputMode" | "type"> {
  ref?: React.Ref<HTMLInputElement>;
}
export function SearchInput(props: SearchInputProps): React.ReactNode {
  return <Input ref={props.ref} prefix={<SearchMdIcon />} inputMode="search" type="search" {...props} />;
}
